import React from 'react';

const ValueContainer = ({ index, children, ...props }) => {
  const { getValue, selectProps } = props;

  return !index && `${selectProps.placeholder} (${getValue().length})`;
};

export default ValueContainer;
